<template>
  <b-row>
    <b-col>
      <b-button-group vertical>
        <b-button v-show="can_update"
          size="sm"
          variant="primary" 
          class="mb-2"
          v-b-tooltip.hover.right title="Go Update"
          @click="$emit('update')"
        >
          <b-icon-triangle aria-label="Update"></b-icon-triangle>
        </b-button>
        <b-button size="sm"
          variant="primary"
          class="mb-2"
          v-b-tooltip.hover.right title="Cancel / Dismiss"
          @click="$emit('cancel')"
        >
          <b-icon-x-circle-fill>aria-label="Cancel"></b-icon-x-circle-fill>
        </b-button>
        <b-button size="sm" v-if="can_help"
          variant="primary"
          class="mb-2"
          v-b-tooltip.hover.right title="Help"
          @click="$emit('help')"
        >
          <b-icon-question-circle-fill> aria-label="Help"></b-icon-question-circle-fill>
        </b-button>
      </b-button-group>
    </b-col>
  </b-row>
</template>

<script>
import {
  BIconXCircleFill,
  BIconTriangle,
  BIconQuestionCircleFill,
} from 'bootstrap-vue'
export default {
  components: {
    BIconXCircleFill,
    BIconTriangle,
    BIconQuestionCircleFill
  },
  props: {
    can_help: {
      Type: Boolean
    },
    can_update: {
      Type: Boolean,
      default: true
    }
  }
}
</script>
